
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/setup",
      function () {
        return require("private-next-pages/settings/setup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/setup"])
      });
    }
  